module.exports = __webpack_public_path__ + "static/img/xljkyzysy.054beca7.svg";